import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import books from '../data/BookDB';
import '../styles/BookDetails.css';
import { FaShoppingCart, FaBolt, FaStar, FaThumbsUp, FaThumbsDown } from 'react-icons/fa';

export default function BookDetailPage() {
  const location = useLocation();

  // Helper to extract query params
  const getQueryParams = (search) => {
    return new URLSearchParams(search);
  };

  const query = getQueryParams(location.search);
  const bookId = query.get('bookId');

  const book = books.find((b) => b.id === parseInt(bookId));

  if (!book) {
    return <div className="not-found">Book not found</div>;
  }

  const {
    title,
    image,
    description,
    author,
    pages,
    rating,
    reviewsCount,
    price,
    offer,
    reviews,
  } = book;

  const discount = Math.round(((price - offer) / price) * 100);

  return (
    <div className="book-detail-page">

<div className="book-details-container">
      <div className="book-left">
        <img src={image} alt={title} className="book-cover" />
      </div>

      <div className="book-right">
        <h2 className="book-title">{title}</h2>
        <p className="book-desc">{description}</p>

        <p className="book-meta">
          <strong>Pages:</strong> {pages}
        </p>

        <p className="book-meta">
          <strong>Author:</strong>{' '}
          <Link to={`/author/${author}`} className="author-link">
            {author}
          </Link>
        </p>

        <div className="rating-section">
          <span className="rating-stars">
            {[...Array(5)].map((_, index) => (
              <FaStar
                key={index}
                className={index < Math.round(rating) ? 'star-filled' : 'star-empty'}
              />
            ))}
          </span>
          <span className="rating-score">{rating} ({reviewsCount} reviews)</span>
        </div>

        <div className="price-section">
          <span className="original-price">₹{price}</span>
          <span className="offer-price">₹{offer}</span>
          <span className="discount">{discount}% off</span>
        </div>

        <div className="button-section">
          <button className="btn cart-btn">
            <FaShoppingCart /> Add to Cart
          </button>
          <button className="btn buy-btn">
            <FaBolt /> Buy Now
          </button>
        </div>

        {/* About the Author Section */}
        <div className="author-section">
          <h3>About the Author</h3>
          <p>
            {author} is a renowned author known for their captivating storytelling and engaging characters.
            With a unique writing style, they have garnered a large following and critical acclaim.
            Their works often explore themes of love, loss, and the human experience.
            {author} has written numerous bestsellers and continues to inspire readers around the world.
          </p>
          <Link to={`/author/${author}`} className="author-link">
            View More Books by {author}
          </Link>
        </div>

        {/* Reviews Section */}
<div className="reviews-section">
  <h3>Reviews</h3>
  {reviews.map((review, index) => (
    <div key={index} className="review-item">
      <div className="review-header">
        <div className="review-avatar">
          {review.user[0].toUpperCase()}
        </div>
        <div className="review-user-info">
          <strong>{review.user}</strong>
          <div className="review-stars">
            {[...Array(5)].map((_, starIndex) => (
              <FaStar
                key={starIndex}
                className={starIndex < Math.round(review.rating || 3.5) ? 'star-filled' : 'star-empty'}
              />
            ))}
            <span className="review-rating">{review.rating || 3.5}</span>
          </div>
        </div>
      </div>
      <p className="review-comment">{review.comment}</p>
      <div className="review-actions">
        <button className="like-btn">
          <FaThumbsUp /> {review.likes || 0}
        </button>
        <button className="dislike-btn">
          <FaThumbsDown /> {review.dislikes || 0}
        </button>
      </div>
    </div>
  ))}
</div>
      </div>
    </div>
    </div>
  );
}
